import RecurrencePatternModal from './RecurrencePatternModal';

export default RecurrencePatternModal;
